import MainLayout from 'app/components/layouts/main/MainLayout'
import RequireAuth from 'app/components/router/require-auth-router'
import LoginContainer from 'app/containers/Login'
import { withLoading } from 'app/hocs/with-loading.hoc'
import { DashboardPage } from 'app/page/menu/dashboard/dashboard'
import ProfilePage from 'app/page/menu/profile'
import DevelopmentPage from 'app/page/other/development'
import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { NotFound } from '../common/NotFound'
import { AccountingRouter } from './accounting-router'
import { CustomerCareRouter } from './customer-care-router'
import { HumanResourcesRouter } from './human-resources-router'
import { InventoryManagementRouter } from './inventory-management-router'
import { MarketingRoute } from './marketing-router'
import NotAuth from './not-auth-router'
import { ReportRouter } from './report-router'
import {
  ANNOUNCEMENT_PATH,
  ATTENDANCE_RECORD_PATH,
  AUTH_PATH,
  CLINIC_MANAGEMENT_PATH,
  COMPANY_PATH,
  DASHBOARD_BOD_PATH,
  DASHBOARD_CONSULTATION_PATH,
  DASHBOARD_DOCTOR_PATH,
  DASHBOARD_NURSE_PATH,
  DASHBOARD_PATH,
  FINANCE_PATH,
  INTERNAL_NEWS_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  MAILBOX_PATH,
  MEDICAL_EXAMINATION_PATH,
  MY_INCOME_PATH,
  MY_REQUESTS_PATH,
  MY_TASKS_PATH,
  ONBOARDING_PATH,
  ORGANIZATIONAL_CHART_PATH,
  PROFILE_PATH,
  PURCHASING_MANAGEMENT_PATH,
  WORK_SCHEDULE_PATH,
} from './route-path'
import { DentalTreatmentManagementRouter } from './dental-treatment-router'
import { UtilitiesManagementRouter } from './utilities-router'
import { DashboardDoctorPage } from 'app/page/menu/dashboard/dashboard-doctor'
import { DashboardConsultationPage } from 'app/page/menu/dashboard/dashboard-consultation'
import { DashboardNursePage } from 'app/page/menu/dashboard/dashboard-nurse'
import { DashboardBodPage } from 'app/page/menu/dashboard/dashboard-bod'
import OrganizationalChartPage from 'app/page/menu/company/organizational-chart'
import { MyDeskRouter } from './my-desk'

const Logout = React.lazy(() => import('./logout-router'))
const AuthLayout = React.lazy(() => import('app/components/layouts/AuthLayout'))

const Dashboard = withLoading(DashboardPage)
const DashboardDoctor = withLoading(DashboardDoctorPage)
const DashboardBod = withLoading(DashboardBodPage)
const DashboardNurse = withLoading(DashboardNursePage)
const DashboardConsultation = withLoading(DashboardConsultationPage)
const DevelopmentDashboard = withLoading(DevelopmentPage)
const OrganizationalChart = withLoading(OrganizationalChartPage)

const AuthLayoutFallback = withLoading(AuthLayout)
const LogoutFallback = withLoading(Logout)

export const AppRouter: React.FC = () => {
  const protectedLayout = (
    <RequireAuth>
      <MainLayout />
    </RequireAuth>
  )

  const authLayout = (
    <NotAuth>
      <AuthLayoutFallback />
    </NotAuth>
  )

  return (
    <BrowserRouter>
      <Routes>
        <Route path={DASHBOARD_PATH} element={protectedLayout}>
          <Route index element={<Dashboard />} />
          <Route path={DASHBOARD_BOD_PATH} element={<DashboardBod />} />
          <Route path={DASHBOARD_DOCTOR_PATH} element={<DashboardDoctor />} />
          <Route path={DASHBOARD_NURSE_PATH} element={<DashboardNurse />} />
          <Route
            path={DASHBOARD_CONSULTATION_PATH}
            element={<DashboardConsultation />}
          />

          {ReportRouter()}
          {MyDeskRouter()}
          <Route path={WORK_SCHEDULE_PATH} element={<DevelopmentDashboard />} />
          <Route path={PROFILE_PATH} element={<ProfilePage />} />
          <Route
            path={ATTENDANCE_RECORD_PATH}
            element={<DevelopmentDashboard />}
          />
          <Route path={MAILBOX_PATH} element={<DevelopmentDashboard />} />
          <Route path={MY_REQUESTS_PATH} element={<DevelopmentDashboard />} />
          <Route path={MY_TASKS_PATH} element={<DevelopmentDashboard />} />
          <Route path={MY_INCOME_PATH} element={<DevelopmentDashboard />} />
          <Route
            path={MEDICAL_EXAMINATION_PATH}
            element={<DevelopmentDashboard />}
          />
          <Route path={FINANCE_PATH} element={<DevelopmentDashboard />} />
          <Route
            path={PURCHASING_MANAGEMENT_PATH}
            element={<DevelopmentDashboard />}
          />
          <Route
            path={CLINIC_MANAGEMENT_PATH}
            element={<DevelopmentDashboard />}
          />
          <Route path={COMPANY_PATH}>
            <Route
              path={ORGANIZATIONAL_CHART_PATH}
              element={<OrganizationalChart />}
            />
            <Route
              path={ANNOUNCEMENT_PATH}
              element={<DevelopmentDashboard />}
            />
            <Route
              path={INTERNAL_NEWS_PATH}
              element={<DevelopmentDashboard />}
            />
            <Route path={ONBOARDING_PATH} element={<DevelopmentDashboard />} />
          </Route>
          {DentalTreatmentManagementRouter()}
          {HumanResourcesRouter()}
          {InventoryManagementRouter()}
          {MarketingRoute()}
          {CustomerCareRouter()}
          {AccountingRouter()}
          {UtilitiesManagementRouter()}
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path={AUTH_PATH} element={authLayout}>
          <Route path={LOGIN_PATH} element={<LoginContainer />} />
        </Route>
        <Route path={LOGOUT_PATH} element={<LogoutFallback />} />
      </Routes>
    </BrowserRouter>
  )
}
